export default "__VITE_ASSET__C3xEn5OR__"